module.exports = __webpack_public_path__ + "static/media/playertable icon-3.330d2ec4.svg";